import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-components",
  style: {"flex":"unset","align-items":"flex-start"}
}
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 1,
  class: "remind-ball"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "attachment-upload" }
const _hoisted_6 = {
  class: "image-list",
  ref: "imageListRef"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "form-components",
      style: {"margin":"0"}
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "form-components",
      style: {"margin":"0","flex":"unset"}
    }, null, -1)),
    (!((_ctx.item.field=='business_license'&&_ctx.signMode!=1)||(_ctx.item.field=='protocol_photos'&&_ctx.signMode==1)||(_ctx.item.field=='protocol_photos'&&_ctx.signMode==2&&_ctx.agreementState==-1)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field])
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: _ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field],
                  "popper-class": "remark-popper",
                  placement: "top-start",
                  trigger: "click"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: "https://images.goworkla.cn/wxAppletImg/EnergyValue_result_about.png",
                      class: "label-remark"
                    }, null, -1)
                  ])),
                  _: 1,
                  __: [2]
                }, 8, ["content"]))
              : _createCommentVNode("", true),
            (_ctx.item.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.item.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.item.is_disable&&_ctx.imageList.length<20)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 0,
                    action: _ctx.uploadUrl,
                    class: "upload-demo",
                    "before-upload": _ctx.upLoadFile,
                    limit: 3,
                    disabled: _ctx.item.is_disable
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        disabled: _ctx.item.is_disable
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("上传附件")
                        ])),
                        _: 1,
                        __: [3]
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["action", "before-upload", "disabled"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "image-list-item",
                    key: image
                  }, [
                    (_ctx.usertype!=='wx')
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _ctx.getAbbreviateImg(image),
                          fit: _ctx.fit,
                          onClick: _withModifiers(($event: any) => (_ctx.viewImg(image,index)), ["stop","prevent"]),
                          onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pretreatment = false))
                        }, null, 8, ["src", "fit", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.usertype==='wx')
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 1,
                          src: _ctx.getAbbreviateImg(image),
                          fit: _ctx.fit,
                          "preview-src-list": _ctx.imageList,
                          "initial-index": index,
                          onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pretreatment = false))
                        }, null, 8, ["src", "fit", "preview-src-list", "initial-index"]))
                      : _createCommentVNode("", true),
                    (!_ctx.item.is_disable)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: "https://images.goworkla.cn/wxAppletImg/ban.png",
                          class: "image-list-item-del",
                          onClick: ($event: any) => (_ctx.delImg(index))
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}